import React, { useState, useEffect } from 'react';
import QuizQuestion from './QuizQuestion';
import RandomScorePopup from './RandomScorePopup';
import TimerQuiz from './timerQuiz';
import IncorrectPopup from './IncorrectPopup';

const Quiz = ({ questions, timer, name, activity, handleFinishGame }) => {
  const [currentQuestionIndex, setCurrentQuestionIndex] = useState(0);
  const [score, setScore] = useState(0);
  const [showScorePopup, setShowScorePopup] = useState(false);
  const [showIncorrect, setShowIncorrect] = useState(false);
  const [labelCorrect, setLabelCorrect] = useState('');
  const [status, setStatus] = useState('');
  const [quizFinished, setQuizFinished] = useState(false);
  const [questionDetails, setQuestionDetails] = useState([]);
  const [questionList, setQuestionList] = useState([]);
  const [timeLeft, setTimeLeft] = useState(0);
  const maxQuestion = 15;

  useEffect(() => {
    if (questions.length > 0) {
      let max = 0;
      if (questions.length >= maxQuestion) {
        max = maxQuestion;
      } else {
        max = questions.length;
      }

      // setQuestionList(questions.sort(() => 0.5 - Math.random()).slice(0, max));
      setQuestionList(questions);
    }
  }, [questions]);

  const getMax = () => {
    let max = 0;
    if (questions.length >= maxQuestion) {
      return maxQuestion;
    } else {
      return questions.length;
    }
  };

  useEffect(() => {
    let max = 0;
    if (questions.length >= maxQuestion) {
      max = maxQuestion;
    } else {
      max = questions.length;
    }

    if (currentQuestionIndex >= max) {
      handleFinishGame(score, questionDetails);
      setQuizFinished(true);
    }
  }, [currentQuestionIndex]);

  const handleAnswerSelection = (isCorrect, timeRanOut = false) => {
    let points = 0;
    let status = timeRanOut
      ? 'TIME ELAPSED'
      : isCorrect
      ? 'CORRECT'
      : 'INCORRECT';

    if (timeRanOut) {
      setStatus('TIME ELAPSED');
      setLabelCorrect('Time Elapsed');
    } else {
      if (isCorrect) {
        setStatus('CORRECT');
        setLabelCorrect('Correct');
      } else {
        setStatus('INCORRECT');
        setLabelCorrect('Incorrect');
      }
    }

    if (isCorrect) {
      setShowScorePopup(true);
    } else {
      setShowIncorrect(true);
    }
  };

  const nextQuestionAfterIncorrect = () => {

    setShowIncorrect(false);
    let points = 0;
    setQuestionDetails((prevDetails) => [
      ...prevDetails,
      { status, points, timer: (timer + 1) - timeLeft }
    ]);
    setCurrentQuestionIndex((prev) => prev + 1);
  };

  const handleScoreUpdate = (randomScore) => {

    setScore((prevScore) => prevScore + randomScore);
    setQuestionDetails((prevDetails) => [
      ...prevDetails,
      { status: 'CORRECT', points: randomScore, timer: (timer + 1) - timeLeft }
    ]);
    setShowScorePopup(false);
    setCurrentQuestionIndex((prev) => prev + 1);
  };

  const handleTimeUp = () => {
    handleAnswerSelection(false, true);
  };

  if (quizFinished) {
    return (
      <div className="font-bold text-center text-white bg-black w-screen h-screen flex justify-center items-center">
        Loading...
      </div>
    );
  }

  return (
    <div className="flex flex-col items-center justify-center w-full bg-gray-100 rounded-md p-4">
      {showScorePopup ? (
        <RandomScorePopup onStop={handleScoreUpdate} />
      ) : showIncorrect ? (
        <IncorrectPopup
          onNext={() => nextQuestionAfterIncorrect()}
          label={labelCorrect}
        />
      ) : (
        <div className="relative w-full">
          <div className="flex justify-between items-start">
            <div className="text-lg flex space-x-2 font-bold text-black whitespace-nowrap">
              <div>
                No. {currentQuestionIndex + 1}/{getMax()}
              </div>
            </div>
            <TimerQuiz
              timeLimit={timer}
              onTimeUp={handleTimeUp}
              updateTimeLeft={(val) => {
                setTimeLeft(val);
              }}
            />

            {/* <div className="text-lg flex space-x-2 font-bold text-black whitespace-nowrap">
              <div>Time: {timeLeft}</div>
            </div> */}

            <div className="text-lg flex space-x-2 font-bold text-black whitespace-nowrap">
              <div>Score: {score}</div>
            </div>
          </div>

          <QuizQuestion
            question={questionList[currentQuestionIndex]}
            onAnswer={handleAnswerSelection}
          />
        </div>
      )}
    </div>
  );
};

export default Quiz;
